import axios from 'axios';

import { requestSuccessInterceptor } from '@/services/client/interceptors/requestInterceptors';
import {
  responseFailureInterceptor,
  responseSuccessInterceptor,
} from '@/services/client/interceptors/responseInterceptors';

import { appConfig } from '@/configs';
import { encodeQueryParameter } from './queryParams';

export const client = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  baseURL: appConfig.apiURL,
  paramsSerializer: {
    encode: encodeQueryParameter,
  },
  timeout: 30000,
  validateStatus: function (status) {
    return status >= 200 && status < 300;
  },
});

client.interceptors.request.use(requestSuccessInterceptor);
client.interceptors.response.use(responseSuccessInterceptor, responseFailureInterceptor);
